export default "__VITE_ASSET__DPqJwrz1__"